__turbopack_context__.v({
  "bio": "styles-module__G4rkvW__bio",
  "brandsGrid": "styles-module__G4rkvW__brandsGrid",
  "footer": "styles-module__G4rkvW__footer",
  "fullName": "styles-module__G4rkvW__fullName",
});
